<!--
트래킹검수 > 검수화면 > 검수대상 리스트 > 상품1개 검수화면 컴포넌트
------------------------------------
-->
<template>
    <div
        class="uk-card uk-card-default uk-card-small uk-margin-large-bottom"
    >
        <div class="uk-card-body">
            <!-- 상세버튼 -->
            <div class="uk-text-right" v-if="! hideDetailButton">
                <button
                    type="button"
                    class="uk-button uk-button-default"
                    onclick="$.app.on_event.move(arguments);"
                    :data-url="'/prods/' + prod.id + '/house-prod-info'"
                    data-target="_blank"
                >
                    <span uk-icon="icon: link"></span>
                    상품상세(합배송)
                </button>
            </div>

            <div class="uk-grid-small" uk-grid>
                <div class="uk-width-auto">
                    <!-- 해외상세 버튼 -->
                    <div class="uk-text-center">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-button-large2"
                            onclick="$.app.on_event.move(arguments);"
                            :data-url="prod.vender_url"
                            data-target="_blank"
                        >
                            <i class="material-icons">
                                link
                            </i>
                            해외상세
                        </button>
                    </div>

                    <!-- 이미지 -->
                    <div class="uk-padding-small uk-margin-bottom">
                        <img-zoom :src="prod.img_url" style="width: 300px; height: 300px"></img-zoom>
                        <!--
                        <img-zoom src="https://m.media-amazon.com/images/I/41rBkpEbcsL._AC_SL1001_.jpg" style="width: 300px; height: 300px"></img-zoom>
                        <img-zoom src="https://images.footlocker.com/is/image/EBFL2/IW3635_om1?wid=581&hei=581&fmt=png-alpha" style="width: 300px; height: 300px"></img-zoom>
                        <img-zoom src="https://i.ebayimg.com/images/g/0H8AAOSwVFBkDI-B/s-l1600.webp" style="width: 300px; height: 300px"></img-zoom>
                        <img-zoom src="https://images.footlocker.com/is/image/EBFL2/13011479_a1?wid=519&hei=519&fmt=png-alpha" style="width: 300px; height: 300px"></img-zoom>
                        <img-zoom src="https://dummyimage.com/300/09f.png/fff" style="width: 300px; height: 300px"></img-zoom>
                        -->

                    </div>

                    <!-- 오류버튼 -->
                    <div
                        class="uk-text-center"
                        v-if="displayErrorButton"
                    >
                        <button
                            class="uk-button uk-button-danger uk-button-large2"
                            @click="$refs.error.form()"
                        >
                            <i class="material-icons">
                                error_outline
                            </i>
                            오류설정
                        </button>

                        <!---- 컴포넌트 -->
                        <app-check-set-error
                            ref="error"
                            :csrf-token="csrfToken"
                            :prod-id="prod.id"
                            :session-owner="loginUserId"
                            @done="callbackErrorDone"
                        ></app-check-set-error>
                    </div>

                </div>
                <div class="uk-width-expand">



                    <!-- 상품정보 -->
                    <table class="check-prod-info uk-margin-bottom">
                        <tr>
                            <th class="highlight">
                                <i class="material-icons">
                                    star
                                </i>
                                NAME
                            </th>
                            <td class="highlight name" colspan="3">
                                {{ prod.name }}
                                <app-column
                                    header="상품명(영문)"
                                    horizontal
                                    header-align="right"
                                    body-align="left"
                                    body-size="medium"
                                    v-show="prod.name_eng"
                                >
                                    {{ prod.name_eng }}
                                </app-column>
                            </td>
                            <th :class="prod.vender_code ? 'highlight' : ''">
                                <i class="material-icons">
                                    star
                                </i>
                                SKU
                            </th>
                            <td class="sku" :class="prod.vender_code ? 'highlight' : ''">
                                {{ prod.vender_code }}
                            </td>
                        </tr>

                        <tr>
                            <th :class="prod.amount > 1 ? 'highlight' : ''">
                                <i class="material-icons">
                                    star
                                </i>
                                QTY
                            </th>
                            <td class="amount" :class="prod.amount > 1 ? 'highlight' : ''">
                                {{ prod.amount }}
                            </td>

                            <th class="highlight">
                                <i class="material-icons">
                                    star
                                </i>
                                SIZE
                            </th>
                            <td class="highlight">
                                {{ prod.size }}
                            </td>

                            <th class="highlight">
                                <i class="material-icons">
                                    star
                                </i>
                                COLOR
                            </th>
                            <td class="highlight">
                                {{ prod.color }}
                            </td>
                        </tr>

                        <tr>
                            <th>
                                <i class="material-icons">
                                    attach_money
                                </i>
                                단가
                            </th>
                            <td colspan="3" class="unit-price">
                                {{ prod.unit_price_text }}
                                <div v-show="expensived" class="expensived">고가제품 검수 주의</div>
                            </td>

                            <th>
                                <i class="material-icons">
                                    account_box
                                </i>
                                수취인
                            </th>
                            <td>
                                {{ prod.h_name }}
                            </td>
                        </tr>

                        <!-- 보류요청 -->
                        <tr>
                            <th :class="prod.hold_request ? 'highlight' : null">
                                <i class="material-icons">
                                    star
                                </i>
                                보류요청
                            </th>
                            <td
                                colspan="5"
                            >
                                <request
                                    v-if="prod.hold_request"
                                    :request="prod.hold_request.hold_reason"
                                ></request>
                            </td>
                        </tr>

                        <!-- 검수요청사항 -->
                        <tr>
                            <th :class="prod.check_requests.length > 0 ? 'highlight' : null">
                                <i class="material-icons">
                                    star
                                </i>
                                검수요청 ({{ prod.check_requests.length }})
                            </th>
                            <td
                                colspan="5"
                            >
                                <request
                                    v-for="req in prod.check_requests"
                                    :key="req.id"
                                    :request="req.request"
                                ></request>
                            </td>
                        </tr>
                    </table>

                    <div class="uk-flex uk-flex-between">
                        <!-- 검수대상 카운트 -->
                        <div
                            v-if="prodTotalCountInTracking > 0"
                            class="uk-width-auto prod-count-guide"
                            :class="prodTotalCountInTracking > 1 ? 'multi' : ''"
                        >
                            검수대상
                            <span class="current">{{ prodIndexInTracking }}</span>
                            /
                            <span class="total">{{ prodTotalCountInTracking }}</span>
                        </div>

                        <div class="uk-width-expand">
                            <!-- 보류보관 버튼 -->
                            <div class="uk-text-center uk-margin-bottom" v-if="displayHoldButton">
                                <p class="uk-text-large uk-text-primary">
                                    <i class="material-icons uk-text-middle" style="font-size: 34px">
                                        info
                                    </i>
                                    보류요청 상품입니다.

                                </p>

                                <div class="hold-job-guide">
                                    <span class="uk-text-danger uk-text-bold">검수</span>
                                    후 <span class="uk-text-danger uk-text-bold">[오류]</span> 또는 <span class="uk-text-danger uk-text-bold">[보류보관]</span> 처리하시고,
                                    <span class="uk-text-danger uk-text-bold">[인보이스+리턴레이블]</span>
                                    상품과 함께 꼭 보관해 주세요.
                                </div>

                                <button
                                    class="uk-button uk-button-primary uk-button-large2"
                                    @click="$refs.hold.form()"
                                >
                                    <i class="material-icons">
                                        save_alt
                                    </i>
                                    보류보관
                                </button>


                                <!-- 컴포넌트 -->
                                <app-check-set-hold
                                    ref="hold"
                                    :csrf-token="csrfToken"
                                    :prod-id="prod.id"
                                    :hold-request="prod.hold_request"
                                    @done="callbackHoldDone"
                                >
                                </app-check-set-hold>
                            </div>

                            <!-- 정상버튼 -->
                            <div class="uk-text-center uk-margin-bottom" v-if="displayOkButton">
                                <div class="multi-shipping-warning uk-margin-bottom" v-if="prod.h_prod_count > 1">
                                    <i class="material-icons">
                                        warning
                                    </i>
                                    (주의) 합배송 상품
                                </div>

                                <div class="uk-margin-bottom">
                                    <button
                                        class="uk-button uk-button-primary uk-button-large2"
                                        @click="$refs.ok.form()"
                                    >
                                        <i class="material-icons">
                                            check_circle_outline
                                        </i>
                                        정상 (발송대기)
                                    </button>
                                </div>


                                <!-- 컴포넌트 -->
                                <app-check-set-ok
                                    ref="ok"
                                    :csrf-token="csrfToken"
                                    :prod-id="prod.id"
                                    @done:ready="callbackReady"
                                    @done:pack="house_id => callbackPack(house_id)"
                                >
                                </app-check-set-ok>

                            </div>

                            <!-- 반품안내 -->
                            <div class="uk-text-large uk-text-center" v-if="displayReturnGuide">
                                <p class="uk-text-danger">
                                    반품신청된 상품입니다.<br />
                                    <b>반품작업 담당자</b>에게 알려주세요.
                                </p>

                                <p>
                                    나중에 반품작업을 진행 할 경우,<br />
                                    1. 상품상세 > 상품정보 탭 > <b>보관장소 입력</b> 하세요<br />
                                    2. 보관라벨 출력 후 상품을 실제 보관장소에 갖다놓으세요<br />
                                    3. 상품상세 > 반품 탭 >  반품단계를 <b>반품작업대기</b>로 변경하세요
                                </p>

                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </div>

    </div>
</template>

<script>


    export default {
        components: {
            'request': require('./request.vue').default,
            'img-zoom': require('../../common/img-zoom.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },

            /**
             * 상품정보
             * {
             *     prods의 칼럼들,
             *
             *     house_id,
             *     h_name,
             *     h_prod_count,
             *
             *     check_requests, // 검수요청사항 배열
             *     hold_request, // 보류요청
             * }
             */
            prod: {
                type: Object,
                default: null,
            },


            /**
             * 상품상세버튼 hide 여부
             **/
            hideDetailButton: {
                type: Boolean,
                default: false,
            },


            /**
             * 고가상품 기준가격(현지 currency)
             **/
            expensiveLimit: {
                type: Number,
                default: 200,
            },

            /**
             * 트래킹박스 전체 상품카운트
             * 상품품목 수
             * (낱개수량아님)
             **/
            prodTotalCountInTracking: {
                type: Number,
                default: 0,
            },

            /**
             * 트래킹박스 내 현재상품의 인덱스
             * (몇번째 상품인지..)
             *
             * 첫번째 상품 : 1
             **/
            prodIndexInTracking: {
                type: Number,
                default: 0,
            },


        },
        data: function () {
            return {
            };
        },

        computed: {
            /**
             * 오류버튼 표시
             * @return bool
             */
            displayErrorButton: function () {
                return this.prod.lock_packed === null
                    && this.prod.lock_error === null
                    && this.prod.state !== 99 // 취소
                    && this.prod.state !== 127 // 폐기대상
                    && this.prod.state !== 128 // 폐기요청
                    && this.prod.state !== 129 // 폐기완료
                    && this.prod.lock_return === null; // 반품신청 없을때만
            },

            /**
             * 정상버튼 표시
             * @return bool
             */
            displayOkButton: function () {
                return this.prod.lock_packed === null
                    && this.prod.lock_error === null
                    && this.prod.lock_hold === null
                    && this.prod.lock_hold_req === null
                    && this.prod.lock_pack_ready === null
                    && this.prod.state !== 61 // 발송대기
                    && this.prod.state !== 99 // 취소
                    && this.prod.state !== 127 // 폐기대상
                    && this.prod.state !== 128 // 폐기요청
                    && this.prod.state !== 129 // 폐기완료
                    && this.prod.lock_return === null; // 반품신청 없을때만
            },

            /**
             * 보류보관 버튼 표시
             * @return bool
             */
            displayHoldButton: function () {
                return this.prod.lock_hold_req !== null
                    && this.prod.state !== 99
                    && this.prod.lock_return === null; // 반품신청 없을때만
            },

            /**
             * 반품처리 안내메세지 표시
             * @return bool
             */
            displayReturnGuide: function () {
                return this.prod.lock_return !== null;
            },

            /**
             * 고가상품 여부
             * @return bool
             */
            expensived: function () {
                return this.prod.unit_price >= this.expensiveLimit;
            },
        },

        methods: {
            /**
             * 에러완료 이벤트 리스너
             */
            callbackErrorDone: function () {
                this.$emit('done:error', null);
            },

            /**
             * 보류완료 이벤트 리스너
             */
            callbackHoldDone: function () {
                this.$emit('done:hold', null);
            },

            /**
             * 정상(발송대기) 이벤트 리스너
             */
            callbackReady: function () {
                this.$emit('done:ready', null);
            },

            /**
             * 정상(패킹대기) 이벤트 리스너
             */
            callbackPack: function (house_id) {
                this.$emit('done:pack', house_id);
            },
        },
    }
</script>

<style lang="scss" scoped>


    // 검수상품정보 테이블
    .check-prod-info {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            text-align: left;
            border: 1px solid #cfcfcf;
            font-weight: normal;

            padding: 10px;
            color: #000;
        }

        th {
            font-size: 1.25rem;
            background-color: #fefefe;
            width: 10rem;

            .material-icons {
                vertical-align: middle;
                font-size: 1.75rem;
                color: #aaa;
            }

            &.highlight .material-icons{
                color: #1e87f0 !important;
            }

        }
        td {
            text-align: center;
            font-size: 1.25rem;
            color: #000;

            &.name {

                text-align: left;
            }

            &.unit-price {
                text-align: left;

                .expensived{
                  display: inline-block;
                  margin-left: 1rem;
                  font-size: 2rem;
                  color: #f0506e!important;
                  font-weight: bold;
                }
            }

            &.sku {
                //color: #1e87f0 !important;
                color: #f0506e!important;
                font-weight: bold;
            }

            &.amount {
                font-size: 2rem;
            }


            &.highlight {
                background-color: #ffffdd;
                font-size: 2rem;

                &.name {

                }
                &.amount {
                    color: #1e87f0 !important;
                    font-weight: bold;

                }
            }
        }

    }

    // 합배송 경고
    .multi-shipping-warning {
        padding: 1rem;
        background-color: #ffffcc;
        color: #000;
        border: 1px solid #000;
        display: inline-block;
        font-size: 1.25rem;
        .material-icons {
            vertical-align: middle;
            font-size: 1.5rem;
        }
    }

    // 보류보관처리 안내
    .hold-job-guide {
        padding: 1rem;
        border: 1px solid #cfcfcf;
        background-color: #FFFD7C;
        color: #1e87f0;
        font-size: 1.25rem;
        margin-bottom: 1rem;
    }

    // 검수대상 카운트 안내
    .prod-count-guide {
        padding: 1rem;
        color: #999;
        font-size: 1.5rem;

        &.multi {
            color: #000;
            .current {
                //color: #1e87f0;
                font-size: 2rem;
            }

            .total {
                font-size: 2.5rem;
            }
        }

    }

</style>